import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useEffect } from 'react';

const ModernMuiTable = ({ children, containerSx = {}, tableSx = {}, ...props }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        ...containerSx,
      }}
    >
      <Table
        sx={{
          minWidth: 650,
          '& .MuiTableCell-head': {
            background: '#F8F9FA',
            color: '#2c3e50',
            borderBottom: '2px solid #d1d8e0',
            fontWeight: '600',
            fontSize: '14px',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          },
          '& .MuiTableRow-root': {
            transition: 'background-color 0.2s ease',
            borderBottom: '1px solid #f0f0f0',
            fontSize: '14px',
            '&:hover': {
              backgroundColor: '#f8f9fa !important',
            },
          },
          '& .MuiTableCell-root': {
            border: 'none',
            padding: '12px 16px',
          },
          ...tableSx,
        }}
        {...props}
      >
        {children}
      </Table>
    </TableContainer>
  );
};

export default ModernMuiTable;
